import React from 'react';
import { Col } from 'react-bootstrap';
import InputMask from 'react-input-mask';

//* https://www.npmjs.com/package/react-input-mask - масска для всего

export default class MaskForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            language: 'rus',
            id: '',
            fid: '',
            description: '',
            information: '',
            value: '',
            colorError: '#fff'
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);

    }

    handleBlur(e) {
        this.setState({
            id: e.target.dataset.id,
            fid: `${this.props.nameForm}_${this.props.id}`,
            description: e.target.dataset.description,
            information: e.target.dataset.information
        })
        setTimeout(() => { this.props.onChangeValue(this.state) })
    }

    handleChange(e) {
        e.preventDefault();
        console.log(e.target.value);//test
        this.setState({ value: e.target.value })
    }


    componentDidMount() {
        this.setState({ value: this.props.value })
    }

    render() {

        const width = this.props.width;
        const id = this.props.id;
        const description = this.props.description;
        const placeholder = this.props.placeholder;
        const value = this.state.value;
        const show = this.props.show;
        // const mask = "+7(999)999-9999"
        const mask = this.props.mask;

        return (
            <React.Fragment key={id}>
                <Col sm={width} style={{ visibility: show ? 'visible' : 'collapse' }} >
                    <div className='phone_mask_label'> {placeholder} </div>
                    <InputMask
                        className="form-control phone_form"
                        mask={mask}
                        maskChar="_"
                        data-id={id}
                        data-fid={`${this.props.nameForm}_${id}`}
                        placeholder={placeholder}
                        data-information={placeholder}
                        data-description={description}
                        value={value}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        disabled={this.props.readOnly}
                    />
                </Col>
            </React.Fragment>
        )
    }
}